/**
 * Created by staffanrantzow on 08/11/16.
 */

import { Utils } from 'frilans-finans';

export default class InvoiceValidator {

  static validateSpecification (specification) {
    return specification.length > 4;
  }

  static validateCustomer (customerId) {
    return Utils.isInt(parseInt(customerId)) && parseInt(customerId) > 0;
  }

  static validateInvoiceDate (invoiceDate) {
    return invoiceDate.length > 0;
  }

  static validatePhoneNumberSwedish (phonenumber) {
    if (!phonenumber) {
      return true;
    }

    return this.validatePhoneNumberSwedishStrict(phonenumber);
  }

  static validatePhoneNumberSwedishStrict (phonenumber) {
    if (!phonenumber) {
      return false;
    }

    var normalized = phonenumber.toString().replace('(0)', '').replace(/\D+/gi, '');
    var re = /^(07|467|\+467)(0|2|3|6|9)\d{7}$/;

    return re.test(normalized);
  }

  static validateApartmentNumber (number) {
    return Utils.isNumeric(number) && number.length === 4;
  }

  static validateHsd (rot, data, accommodationType, apartmentNumber, cooperativeApartmentRegistrationNumber) {
    if (rot) {
      if (accommodationType === 'house' && data.length < 4) {
        return false;
      }

      if (accommodationType === 'apartment' &&
        (!this.validateApartmentNumber(apartmentNumber) ||
         !Utils.isVatNumber(cooperativeApartmentRegistrationNumber))) {
        return false;
      }

      return true;
    } else {
      return true;
    }
  }

  /**
   * Validates the sendToEmail property.
   * If sendToEmail is undefined it means it hasn't been
   * added to the params and the invoice should be send by letter.
   * In that case this is valid.
   *
   * @param sendToEmail
   * @returns {boolean}
   */
  static validateSendToEmail (sendToEmail) {
    if (typeof sendToEmail === 'undefined' || sendToEmail === '') {
      return true;
    }

    return this.validateEmail(sendToEmail);
  }

  static validateEmail (email) {
    /*eslint-disable */
    var re = /^(([^<>()\[\]\\.,;:\s@"äöå]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([åäöa-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /*eslint-enable */

    let validEmail = re.test(email);

    return validEmail;
  }

  static validateSendToEinvoiceAddress (sendToEinvoiceAddress) {
    if (!sendToEinvoiceAddress) {
      return true;
    }
    return Utils.isValidEinvoiceAddress(sendToEinvoiceAddress);
  }

  static validateAmount (amount) {
    return Utils.isNumeric(amount) && amount !== 0;
  }

  static validatePositiveAmount (invoiceusers) {
    let isPositive = true;
    invoiceusers.forEach(invoiceuser => {
      if (invoiceuser.gross < 0) {
        isPositive = false;
      }
    });
    return isPositive;
  }

  static validateMaxHours (invoiceDate) {
    return invoiceDate.find(date => date.hours > 24) === undefined;
  }

  static validateInvoicing (invoice) {
    if (invoice.message_type === 'email') {
      return this.validateEmail(invoice.send_to_email);
    }
    if (invoice.message_type === 'sms') {
      return this.validatePhoneNumberSwedishStrict(invoice.company_phone);
    }
    if (invoice.message_type === 'e-invoice') {
      return Utils.isValidEinvoiceAddress(invoice.e_invoice_address);
    }
    return true;
  }

  /**
   * Validates all added fields of an invoice
   *
   * @param invoice has the post reqest format for all params
   * @returns {*}
   */
  static invoiceIsValid (invoice) {
    // TODO: Add all coming functions to this condition
    let hsdValidate = true;

    if (invoice.hsd !== undefined) {
      let hsd = invoice.hsd;
      hsdValidate = this.validateHsd(hsd.rot, hsd.data, hsd.accommodation_type,
        hsd.apartment_number, hsd.cooperative_apartment_registration_number);
    }

    return this.validateSpecification(invoice.specification) &&
      this.validateCustomer(invoice.company_id) &&
      this.validateInvoiceDate(invoice.invoicedate) &&
      this.validateSendToEmail(invoice.send_to_email) &&
      this.validateSendToEinvoiceAddress(invoice.e_invoice_address) &&
      this.validatePhoneNumberSwedish(invoice.company_phone) &&
      hsdValidate &&
      this.validateAmount(invoice.amount) &&
      this.validatePositiveAmount(invoice.invoiceuser) &&
      this.validateMaxHours(invoice.invoicedate) &&
      this.validateInvoicing(invoice);
  }

}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/invoice/invoice-validator.js
 **/